import LayoutRendererState, {
    PendingWidgetToAdd,
} from 'layoutRenderer/LayoutRendererState';
import { Action } from 'store/store';
import { WidgetId } from 'widgets/WidgetId';

export enum LayoutRendererActionType {
    LOCK_LAYOUT = 'LOCK_LAYOUT',
    UNLOCK_LAYOUT = 'UNLOCK_LAYOUT',
    REQUEST_ADD_WIDGETS = 'REQUEST_ADD_WIDGETS',
    CONFIRM_ADD_WIDGETS = 'CONFIRM_ADD_WIDGETS',
}

export type RequestAddWidgetsAction = Action<
    LayoutRendererActionType.REQUEST_ADD_WIDGETS,
    PendingWidgetToAdd[]
>;

export type ConfirmAddWidgetsAction = Action<
    LayoutRendererActionType.CONFIRM_ADD_WIDGETS,
    { ids: WidgetId[] }
>;

export type UnlockLayoutAction = Action<
    LayoutRendererActionType.UNLOCK_LAYOUT,
    LayoutRendererState
>;

export type LayoutRendererAction =
    | Action<LayoutRendererActionType.LOCK_LAYOUT, LayoutRendererState>
    | UnlockLayoutAction
    | RequestAddWidgetsAction
    | ConfirmAddWidgetsAction;

export const lockLayout = () => ({
    type: LayoutRendererActionType.LOCK_LAYOUT,
});

export const unlockLayout: () => UnlockLayoutAction = () => ({
    type: LayoutRendererActionType.UNLOCK_LAYOUT,
});

export const createRequestAddWidgetsAction = (
    widgets: PendingWidgetToAdd[]
): RequestAddWidgetsAction => ({
    type: LayoutRendererActionType.REQUEST_ADD_WIDGETS,
    payload: widgets,
});

export const confirmAddWidgets = (
    ids: WidgetId[]
): ConfirmAddWidgetsAction => ({
    type: LayoutRendererActionType.CONFIRM_ADD_WIDGETS,
    payload: { ids },
});
